import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "../../services/CRUDServices";

export const filterOrderInternal: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "order-internal",
  async (body: any) => {
    let { data } = await filterTableDataAPI(
      "/consignment-api/internalConsignmentWizard/filter",
      body.pageNumber,
      {
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },
      true,
      10,
      false
    );
    return { data:data.payload };
  }
);

const initialState: any = {
  orderInternalLists: [],
  fetchpost: false,
  errorMessage: null,
  filter: {},
};

const OrderInternalSlice = createSlice({
  initialState: initialState,
  name: "order-internal",
  reducers: {

    // clearGroupPayment: (state) => {
    //   state.deliveryList = [];
    // },
    setFilterOrderInternal: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterOrderInternal.fulfilled as any]: (state, action) => {
      state.orderInternalLists = action.payload.data;
      state.fetchpost = false;
    },
    [filterOrderInternal.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterOrderInternal.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const {  setFilterOrderInternal } = OrderInternalSlice.actions;
export default OrderInternalSlice.reducer;
